export default {
  activeLocation: null,
  locations: [],
}
